import { Box } from '@mui/material';
import { makeStyles } from 'tss-react/mui';


export type MainLayoutContainerProps = {
  noTopPadding?: boolean;
  noContainerPadding?: boolean;
  className?: string;
};

const useStyles = makeStyles({ name: 'MainLayoutContainer' })(theme => ({
  root: {
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    [theme.breakpoints.up('md')]: {
      padding: theme.spacing(5, 10),
    },
    [theme.breakpoints.down('sm')]: { // iPhone 365px
      paddingTop: 30,
      padding: 16,
    },
    [theme.breakpoints.down('md')]: { // iPad 768px
      paddingTop: 30,
      padding: 16,
    },
  },
  noContainerPadding: {
    paddingLeft: 0,
    paddingRight: 0,
  },
  noTopPadding: {
    paddingTop: 0,
    paddingBottom: 0,
  },
}));


export const MainLayoutContainer: React.FC<MainLayoutContainerProps> = ({ noTopPadding, noContainerPadding, children, className }) => {
  const { classes, cx } = useStyles();

  const combinedClassName = cx(classes.root, className, {
    [classes.noContainerPadding]: noContainerPadding,
    [classes.noTopPadding]: noTopPadding,
  });

  return (
    <Box className={combinedClassName}>
      {children}
    </Box>
  );
};
